import React from 'react';
import { connect } from 'react-redux';
import NotificationsAnnouncementCircleAnnouncement from '../../components/modals/CircleAnnouncement/NotificationsAnnouncementCircleAnnouncement';
import CircleAnnouncementWalkthrough from '../../components/modals/CircleAnnouncement/CircleAnnouncementWalkthrough';
import DelaysAnnouncementCircleMultiple from '../../components/modals/CircleAnnouncement/DelaysAnnouncementCircleMultiple';

import ModalBannerConstants from '../../constants/ModalBannerConstants';
import './CircleGlobalModal.scss';
import dataModel from '../../models/DataModel';

const MODAL_COMPONENTS = {
  [ModalBannerConstants.NOTIFICATIONS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT]: NotificationsAnnouncementCircleAnnouncement,
  [ModalBannerConstants.DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT]: CircleAnnouncementWalkthrough,
  [ModalBannerConstants.DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT_MULTIPLE]: DelaysAnnouncementCircleMultiple,
};

export class CircleGlobalModal extends React.Component {

  constructor(props) {
    super(props);
        
    this.state = {
      dontAnimating: false,
    };

    this.handleOnClose = this.handleOnClose.bind(this);
  }

  onComponentDidMount() {
  }

  handleOnClose() {
    dataModel.hideCircleGlobalModal();
  }
  
  render() {
    if (!this.props.modalType) {
      return null;
    }
    const SpecificModal = MODAL_COMPONENTS[this.props.modalType];
    const modalProps = Object.assign({}, this.props, { onClose: this.handleOnClose });
    return <div className={'circle-global-modal' + (modalProps.modalProps && modalProps.modalProps.side ? ' ' + modalProps.modalProps.side : ' bottom-right-side')}>
      <SpecificModal {...modalProps} />
      </div>;
  }
}

export default connect(
  state => (state.main.circleGlobalModal ? state.main.circleGlobalModal : {})
)(CircleGlobalModal);



// WEBPACK FOOTER //
// ./src/containers/CircleGlobalModal/index.js